import React, { useState } from 'react';
import { DemoCredentialWithPassword, DemoCredential } from '../data/demoCredentials';

interface LoginScreenProps {
  users: DemoCredentialWithPassword[];
  onLoginSuccess: (credential: DemoCredential) => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ users, onLoginSuccess }) => {
  const [emailInput, setEmailInput] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const normalizedEmail = emailInput.trim().toLowerCase();
    const matchingUser = users.find((user) => user.email.toLowerCase() === normalizedEmail);

    if (!matchingUser) {
      setError('No account found for that email.');
      return;
    }

    if (matchingUser.password !== password) {
      setError('Invalid password for this account.');
      return;
    }

    setError(null);
    setPassword('');
    setEmailInput('');
    onLoginSuccess({
      userId: matchingUser.userId,
      email: matchingUser.email,
      displayName: matchingUser.displayName
    });
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__header">
          <div>
            <h1>Prompt Editor</h1>
          </div>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <label className="login-label">
            Email
            <input
              className="login-input"
              type="email"
              value={emailInput}
              onChange={(event) => setEmailInput(event.target.value)}
              placeholder="name@go2.io"
              required
            />
          </label>

          <label className="login-label">
            Password
            <input
              className="login-input"
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter the provided password"
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="login-submit">
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
